import { Box } from '@mui/system';
import { RiSettings2Line } from '@remixicon/react';
import type { ReactNode } from 'react';
import Flex from 'src/components/atoms/Flex';
import { AgText } from 'src/components/ui';
import { CustomizeTable, ToolbarButton } from 'src/modules/grids/toolbar';

type EditableGridToolbarProps = {
  title?: string;
  rowCountLabel?: string;
  displayRowCount: number;
  toolbarButtons?: ReactNode;
  disabledColumns?: Record<string, boolean>;
  /** The caller's `columnVisibilityModel`: it overrides the user's choice, so its columns can't be toggled. */
  controlledVisibility?: Record<string, boolean>;
  bannerContent?: ReactNode;
};

export function EditableGridToolbar({
  title,
  rowCountLabel,
  displayRowCount,
  toolbarButtons,
  disabledColumns,
  controlledVisibility,
  bannerContent,
}: EditableGridToolbarProps) {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          pb: 1,
          pt: title || rowCountLabel ? 1 : 0,
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {rowCountLabel ? (
          <AgText className="text-[14px]" style={{ color: 'rgba(15, 19, 36, 0.60)' }}>
            {displayRowCount} {rowCountLabel}
            {displayRowCount !== 1 ? 's' : ''}
          </AgText>
        ) : title ? (
          <AgText size="h6">{title}</AgText>
        ) : (
          <div />
        )}
        <Flex gap={2}>
          {toolbarButtons}
          <ToolbarButton icon={<RiSettings2Line size={16} />}>
            {(close) => (
              <CustomizeTable
                closeMenu={close}
                disabledColumns={disabledColumns}
                controlledVisibility={controlledVisibility}
              />
            )}
          </ToolbarButton>
        </Flex>
      </Box>
      {bannerContent}
    </>
  );
}
